import { isEqual } from 'lodash';

function isVariableValueEqual(a, b) {
  if (a === b) {
    return true;
  }
  return isEqual(a, b);
}
function safeStringifyValue(value) {
  const getCircularReplacer = () => {
    const seen = /* @__PURE__ */ new WeakSet();
    return (_, value2) => {
      if (typeof value2 === "object" && value2 !== null) {
        if (seen.has(value2)) {
          return;
        }
        seen.add(value2);
      }
      return value2;
    };
  };
  try {
    return JSON.stringify(value, getCircularReplacer());
  } catch (error) {
    console.error(error);
  }
  return "";
}
function renderPrometheusLabelFilters(filters) {
  return filters.map((filter) => renderFilter(filter)).join(",");
}
function renderFilter(filter) {
  let value = "";
  if (filter.operator === "=~" || filter.operator === "!~\xA8") {
    value = escapeLabelValueInRegexSelector(filter.value);
  } else {
    value = escapeLabelValueInExactSelector(filter.value);
  }
  return `${filter.key}${filter.operator}"${value}"`;
}
function escapeLabelValueInExactSelector(labelValue) {
  return labelValue.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/"/g, '\\"');
}
function escapeLabelValueInRegexSelector(labelValue) {
  return escapeLabelValueInExactSelector(escapeLokiRegexp(labelValue));
}
const RE2_METACHARACTERS = /[*+?()|\\.\[\]{}^$]/g;
function escapeLokiRegexp(value) {
  return value.replace(RE2_METACHARACTERS, "\\$&");
}

export { escapeLabelValueInExactSelector, escapeLabelValueInRegexSelector, isVariableValueEqual, renderPrometheusLabelFilters, safeStringifyValue };
//# sourceMappingURL=utils.js.map
